import { NgModule } from '@angular/core';
import { NgbPopoverModule, NgbModule, NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { SideBarComponent } from './side-bar/side-bar.component';
import { NotificationService } from '../services/notification.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Authentication } from '../services/authentication.service';
import { UiModule } from '../UI/ui/ui.module';
import { HeaderNewComponent } from './header-new/header-new.component';
import { MatIconModule } from '@angular/material/icon';
import { ExpirationBannerComponent } from '../components/expiration-banner/expiration-banner.component';

@NgModule({
  declarations: [LayoutComponent, SideBarComponent, HeaderNewComponent, ExpirationBannerComponent],
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, UiModule, NgbPopoverModule, MatIconModule, NgbModule, NgbAlertModule],
  providers: [Authentication, NotificationService],
})
export class LayoutsModule {}
